export var Api;
(function (Api) {
    Api["AUTH_PROVIDER_LOOKUP"] = "/api/accountholder/authentications/lookup";
    Api["PRECHECKOUT_IDENTITY_VERIFICATION"] = "/api/identities/verification";
    Api["PRECHECKOUT_IDENTITY_VALIDATION"] = "/api/identities/validation";
})(Api || (Api = {}));
